import { cssClass } from '../../style';

export const EMAIL_DISPLAY_NAME_FORM = 'EmailDisplayNameForm';

export const textFieldWidget = cssClass(EMAIL_DISPLAY_NAME_FORM, 'textfield-widget', {
  $nest: {
    '& input': {
      width: 300
    }
  }
});

export const userNameThirdCell = cssClass(EMAIL_DISPLAY_NAME_FORM, 'username-third-cell', {
  width: 253,
  minWidth: 253,
});

export const buttonCell = cssClass(EMAIL_DISPLAY_NAME_FORM, 'button-cell', {
  $nest: {
    '& button': {
      width: 206
    }
  }
});